import GetCouponByCouponCode from '@/services/coupons/couponService/GetCouponByCouponCode';
import GetAnyCouponByCouponCode from '@/services/coupons/couponService/GetAnyCouponByCouponCode';
import GetCurrentPauseCoupon from '@/services/coupons/couponService/GetCurrentPauseCoupon';
import RedeemPauseCoupon from '@/services/coupons/couponService/RedeemPauseCoupon';

export default class CouponService {
    static getCouponByCouponCode(coupon) {
        return (new GetCouponByCouponCode()).handle(coupon);
    }

    static getAnyCouponByCouponCode(coupon) {
        return (new GetAnyCouponByCouponCode()).handle(coupon);
    }

    static getCurrentPauseCoupon() {
        return (new GetCurrentPauseCoupon()).handle();
    }

    static redeemPauseCoupon(couponId) {
        return (new RedeemPauseCoupon()).handle(couponId);
    }
}
